import { emailSchema } from '@retainerclub/common';
import * as Yup from 'yup';

function schema() {
  return Yup.object().shape({
    firstName: Yup.string().required('first name is required'),
    lastName: Yup.string().required('last name is required'),
    email: emailSchema({ required: true }),
    phone: Yup.string()
      .required('mobile number is required')
      .test('phone-format', 'mobile number must be valid', (value) => {
        if (!value) {
          return false;
        }
        // Remove all non-digit characters to check the total length
        const digitsOnly = value.replace(/\D/g, '');
        // Should be at least 11 digits (country code + 10 digit number)
        // This accommodates different country code lengths
        return digitsOnly.length >= 11;
      }),
  });
}

export default schema;
